import { cn } from '@scalis/utils'
import { dividerClassname } from './divider.styles'
import { DividerProps } from './divider.types'

export const Divider = ({ className, vertical, children, dividerClassName: dividerCls }: DividerProps) => {
  if (children)
    return (
      <div className={cn('grid w-full grid-cols-[1fr_7.5rem_1fr] items-center justify-center', className)}>
        <div className={dividerClassname({ className: dividerCls })} />
        {children}
        <div className={dividerClassname({ className: dividerCls })} />
      </div>
    )
  return <div className={dividerClassname({ vertical, className: dividerCls })} />
}
